import { render, staticRenderFns } from "./KnFormTitle.vue?vue&type=template&id=800b668a&"
import script from "./KnFormTitle.vue?vue&type=script&lang=js&"
export * from "./KnFormTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports